// Utils
import globalLogger from '../logger';
import { isFeatureEnabled, getIsGuestProp, isStaff } from '../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentUser } from '../user/currentUserSelector';

const logger = globalLogger.createChannel('redux.utils');

export const dispatchSelector = (selectorFn) => (props) => (dispatch, getState) => selectorFn(getState(), props);

export const featureCheckAction =
    (featureName, staffEnabled = false) =>
    (actionFn) =>
    (...args) =>
    (dispatch, getState) => {
        const state = getState();
        const user = getCurrentUser(state);

        if (getIsGuestProp(user)) {
            // Sensitive data audit: SAFE — User ID is an internal opaque identifier (pseudonymous, non-PII by itself) and permitted for logging
            logger.warn('The "%s" feature is not enabled for guests', featureName, { userId: user._id });
            return;
        }

        const enabled = (staffEnabled && isStaff(user)) || isFeatureEnabled(featureName, user);

        if (!enabled) {
            // Sensitive data audit: SAFE — User ID is an internal opaque identifier (pseudonymous, non-PII by itself) and permitted for logging
            logger.warn('This "%s" feature is not enabled for this user', featureName, { userId: user._id });
            return;
        }

        // Sensitive data audit: SAFE — Only logs feature name, not user data
        logger.info('Feature is being used', featureName);

        return dispatch(actionFn(...args));
    };
